var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 40,
    viewBox: "0 0 128 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0345 10.9617L22.6255 30.031L11.7188 10.9617H5.16474L0 39.8855H6.5482L9.95855 20.809L20.8634 39.8855H27.418L32.5827 10.9617H26.0345Z",
    fill: "#1B1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3982 20.2003L82.0702 25.4435L71.9226 39.8841H64.5654L78.3982 20.2003Z",
    fill: "#00916E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9171 10.9603H64.5659L75.8906 27.1084L79.5694 21.8728L71.9171 10.9603Z",
    fill: "#00916E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7788 26.8596L80.0955 32.1036L85.6643 40H93.0214L83.7788 26.8596Z",
    fill: "#1B1B1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.078 10.9635H115.695L115.695 10.9617H109.147V10.9635H96.4862L95.5031 16.4761H108.161L103.977 39.8855H110.531L114.711 16.4761H126.109L127.078 10.9635Z",
    fill: "#1B1B1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2166 9.9511L94.9425 0L86.7198 6.17994L88.0338 6.65212L86.099 9.24037L79.7952 18.2077L83.4717 23.4505L88.5721 16.1933L93.8348 8.73642L97.2166 9.9511Z",
    fill: "#1B1B1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5124 10.9631V11.1372L60.5116 16.7366H36.2845L37.3161 10.9631H61.5124ZM32.1455 39.8855H56.3726L57.3733 34.286V34.1119H33.1771L32.1455 39.8855ZM34.2137 28.311H58.4408L59.4415 22.7116V22.5375H35.2453L34.2137 28.311Z",
    fill: "#1B1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextLogoWhite);
export default __webpack_public_path__ + "static/media/next-logo-white.aaf097ed7d2498129d7a17f75848f15e.svg";
export { ForwardRef as ReactComponent };